import { FormattedMessage as FM } from "react-intl";

function TableGuest({ guests, TYPES, PREFIX }) {
  if (!guests.length) {
    return (
      <div className="text-center text-gray-600">
        {" "}
        <FM id="hotel.folio.guest.guests_no_found" />
      </div>
    );
  }

  return (
    <div className="w-full overflow-x-auto p-3">
      <table className="table-auto w-full rounded-2xl overflow-hidden shadow-md">
        <thead className="text-left bg-yellow-400 py-2">
          <tr className="whitespace-nowrap">
            <th className="px-8 py-3 font-semibold ">
              <FM id="hotel.folio.guest.name" />
            </th>
            <th className="px-8 py-3 font-semibold ">
              <FM id="hotel.folio.guest.typeDocument" />
            </th>
            <th className="px-8 py-3 font-semibold ">
              <FM id="hotel.folio.guest.id_number" />
            </th>
            <th className="px-8 font-semibold ">
              <FM id="hotel.folio.guest.type_accomodation" />
            </th>
          </tr>
        </thead>

        <tbody>
          {guests.map((guest, index) => {
            const typeDocumentGuest = TYPES.find(
              (item) => item.id == guest.type_document,
            )?.name;

            const rowItems = [
              guest.name,
              <FM id={`${PREFIX}.${typeDocumentGuest}`} />,
              guest.id_number,
              guest.type_guest,
            ];

            return (
              <tr
                key={index}
                className="[&:nth-child(even)]:bg-gray-100 rounded-2xl text-left"
              >
                {rowItems.map((item, idx) => (
                  <td
                    key={idx}
                    className={`px-8 py-3 capitalize ${
                      idx === 0 ? "whitespace-nowrap w-0 " : ""
                    }`}
                  >
                    {item}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default TableGuest;
